module.exports = __webpack_public_path__ + "img/002.ed95e62d.jpg";